<script>
import FAQQuestion from '@/components/FAQQuestion.vue'
import Rainbow from '@/components/Rainbow.vue'
import { allFAQ } from '@/data/faqdata'

export default {
  name: 'FAQ',
  data() {
    return {
      faqs: allFAQ,
    }
  },
  components: {
    Rainbow,
    FAQQuestion,
  },
}
</script>

<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="12" class="inset">
        <h1 class="mt-8">Frequently Asked Questions</h1>
        <Rainbow style="width: 150px;" class="mb-8" thickness="8px" />
      </v-col>
      <v-col cols="12" class="inset" justify="start">
        <v-row>
          <v-col cols="12">
            <v-expansion-panels style="text-align: left;">
              <v-expansion-panel v-for="section in faqs" :key="section.title">
                <v-expansion-panel-header>
                  <h4>{{ section.title }}</h4>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-expansion-panels flat>
                    <FAQQuestion
                      v-for="(faq, i) in section.faqs"
                      :key="i"
                      :question="faq.question"
                      :answer="faq.answer"
                    />
                  </v-expansion-panels>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>

          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<style lang="scss" scoped>
h4 {
  font-weight: 500;
  font-size: 18px;
}
.faqheader {
  text-align:center;
  margin: 0 auto;
  width: 50%;
}

@media only screen and (max-width: 960px) {
  .faqheader {
    width: 100%;
  }
}
</style>
